import React, { useState } from "react";
import { Card } from "react-bootstrap";
import Rating from "./Rating";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../actions/cartActions";

function Product({ product }) {
	const dispatch = useDispatch();
	const [qty, setQty] = useState(0);

	const addToCartHandler = () => {
		if (qty < product.countInStock) {
			const newQty = qty + 1;
			setQty(newQty);
			dispatch(addToCart(product._id, newQty));
		}
	};

	return (
		<div className="my-2 rounded d-flex flex-wrap">
			{product.countInStock > 0 ? (
				<Card.Text className="text-success position-absolute fs-6 m-0">
					In Stock{" "}
					<span className="fas fa-check text-white bg-success rounded-circle"></span>
				</Card.Text>
			) : (
				<Card.Text className="text-warning position-absolute  fs-6 m-0">
					Pre Order{" "}
					<span className="fas fa-check text-white bg-warning rounded-circle"></span>
				</Card.Text>
			)}

			<Link className="ps-1 mt-3 pe-3" to={`/product/${product._id}`}>
				<Card.Img
					alt={product.name}
					style={{ maxWidth: "200px", maxHeight: "200px" }}
					src={product.image}
					loading="lazy"
				/>
			</Link>

			<Card.Body>
				<Link className="text-decoration-none" to={`/product/${product._id}`}>
					<Card.Title as="div">
						<strong className="text-black fs-6">{product.name}</strong>
					</Card.Title>
				</Link>

				<Card.Text as="div">
					<div className="my-1 fs-6">
						<Rating
							value={product.rating}
							text={`${product.numReviews} reviews`}
							color={"#f8e825"}
						/>
					</div>
				</Card.Text>

				<div className="d-flex justify-content-between align-items-center">
					<Card.Text className="text-black fw-bold fs-6 mb-0" as="p">
						{product.price} <span className="text-capitalize">Birr</span>
					</Card.Text>

					<button
						hidden={product.countInStock === 0}
						onClick={addToCartHandler}
						className="rounded-2 border-0 tomato  text-black">
						<span className="fas fa-cart-plus"></span>
					</button>
				</div>
			</Card.Body>
		</div>
	);
}

export default Product;
